import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { GraphDotnetService, graphql, MediaclipMutationUpdateStoreConfigArgs, SortOrder, StoreConfig, StoreWebhookLog, UpdateStoreConfigInput } from 'app/shared/graph';

@Injectable({ providedIn: 'root' })
export class StoreWebhookLogsService {
    private readonly graphDotnetService = inject(GraphDotnetService);

    getStoreWebhookLogEnabled(storeId: string): Observable<boolean> {
        return this.graphDotnetService.query(graphql`
                query getStoreSettings($storeId: String!) {
                    store(id: $storeId) {
                        config {
                            webhookLogEnabled
                        }
                    }
                }
            `,
            {
                storeId
            }
        ).pipe(map(q => q.store.config.webhookLogEnabled || false));
    }

    updateStoreConfig(input: UpdateStoreConfigInput): Observable<void> {
        return this.graphDotnetService.mutate<MediaclipMutationUpdateStoreConfigArgs>(
            graphql`
                mutation updateStoreConfig($input: UpdateStoreConfigInput!) {
                    updateStoreConfig(input: $input)
                }
            `,
            { input }
        ).pipe(map(x => x.updateStoreConfig));
    }

    getStoreWebhookLogs(
        storeId: string,
        top: number,
        offset: number,
        dateOrdering: SortOrder | null,
        startDate: Date | undefined,
        endDate: Date | undefined
    ): Observable<StoreWebhookLog[]> {
        return this.graphDotnetService.query(graphql`
                query getStoreWebhookLogs(
                    $storeId: String!,
                    $top: Int,
                    $offset: Int,
                    $startDate: DateTime,
                    $endDate: DateTime,
                    $dateOrdering: SortOrder!,
                ) {
                    store(id: $storeId) {
                        webhookLogs(
                            top: $top,
                            offset: $offset,
                            startDate: $startDate,
                            endDate: $endDate,
                            dateOrdering: $dateOrdering,
                        ) {
                            url
                            statusCode
                            sentDateUtc
                            requestHeaders {
                                name
                                value
                            }
                            requestBody
                            responseHeaders {
                                name
                                value
                            }
                            responseBody
                        }
                    }
                }
            `,
            {
                storeId,
                top,
                offset,
                startDate,
                endDate,
                dateOrdering
            }
        ).pipe(map(q => q.store.webhookLogs));
    }
}
